import { createAuthenticatedFetch } from '@weareopenr/authkit';
import { getBrandId } from '../../helpers/getBrandId/getBrandId';

export const fetch = async (url: string, options?: RequestInit & { includeBrandId?: boolean }) => {
  const brandId = getBrandId();

  const { includeBrandId, ...restOptions } = options || {};

  const apiFetch = createAuthenticatedFetch({
    headers: {
      ...restOptions?.headers,
      ...(includeBrandId !== false && { 'brand-id': brandId }),
    },
  });
  const requestOptions: RequestInit = {
    ...restOptions,
  };
  return apiFetch(url, requestOptions);
};
